import {
    createRef,
    forwardRef,
    CSSProperties,
    FunctionComponent,
    InputHTMLAttributes,
    useImperativeHandle,
} from 'react';

interface UploadProps {
    accept?: string;
    className?: string;
    style?: CSSProperties;
}

const Upload: FunctionComponent<InputHTMLAttributes<HTMLInputElement> & UploadProps & React.RefAttributes<any>> =
    forwardRef(({ className, children, accept, style, ...props }, ref) => {
        const inputRef = createRef<HTMLInputElement>();

        useImperativeHandle(ref, () => ({
            reset: () => {
                inputRef.current.value = '';
            },
        }));

        return (
            <span style={style} className={className} onClick={() => inputRef.current.click()}>
                <input {...props} type={'file'} ref={inputRef} accept={accept} style={{ display: 'none' }} />

                {children}
            </span>
        );
    });

Upload.defaultProps = {
    style: {},
    className: '',
    multiple: false,
    accept: 'image/*',
    onChange: () => null,
};

export default Upload;
